import axios from 'axios'

const BASE_URL = window.URL_API_CHALLENGE

export const userChallenges = (userId, parameters) => {
    let url = Object.keys(parameters).map(function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(parameters[k])
    }).join('&')
    
    return axios.get(`${BASE_URL}/challenges/user/${userId}?${url}`)
}


// WEBPACK FOOTER //
// ./src/App/utils/challenge.js